import { BadgeButton } from './Badge';
import { ReactNode } from 'react';
import { createStyles } from '@mantine/core';
import { isDark } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';
import { useRouter } from 'next/navigation';

const useMenuItemStyle = createStyles((_, dark: any) => ({
  linkItemContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    padding: 14,
    borderRadius: '0.75rem',
    color: themeVariables.fontColors.medium,
    fontSize: 14,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: dark?.dark
        ? themeVariables.colors.darkHover
        : themeVariables.colors.light100,
    },
    img: {
      width: 32,
      height: 32,
      alignItems: 'center',
      borderRadius: '0.5rem',
      marginRight: 12,
    },
  },

  normalItemContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    padding: 14,
    borderRadius: '0.75rem',
    color: themeVariables.fontColors.light,
    fontSize: 14,
    img: {
      width: 32,
      height: 32,
      alignItems: 'center',
      borderRadius: '0.5rem',
      marginRight: 12,
    },
  },

  leftElementContainer: {},

  rightElementContainer: {
    minWidth: 0,
  },

  badgeContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 12,
    gap: 6,
  },
}));

type Props = {
  leftElement?: ReactNode;
  rightElement?: ReactNode;
  techstackIds?: string[];
  onClick?: any;
};

const MenuItem = ({
  leftElement,
  rightElement,
  techstackIds,
  onClick,
}: Props) => {
  const { dark } = isDark();
  const { classes } = useMenuItemStyle({ dark });
  const { push: navigate } = useRouter();

  return (
    <div
      className={
        onClick ? classes.linkItemContainer : classes.normalItemContainer
      }
      onClick={onClick}
    >
      {leftElement}
      <div
        className={classes.rightElementContainer}
        style={{
          color: themeVariables.darkMode.normal(dark),
        }}
      >
        {rightElement}
        {techstackIds && techstackIds?.some((item) => !!item) && (
          <div className={classes.badgeContainer}>
            {techstackIds.map((techstackId, idx) => (
              <BadgeButton
                key={idx}
                text={techstackId}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/techstack/detail/${techstackId}`);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuItem;
